import { IProjectMetadata } from '@/interfaces/report';
import { UnitSystem } from '@/interfaces/units';
import { IAsphaltDesignImperial } from '@/modules/design/interfaces/newAsphalt';
import { BaseScenarioType } from '@/lib/types/IBaseScenario';
import { DesignScenarioType, EsalCalculationMethods } from '@/modules/design/interfaces/shared';
import {userStore} from "@/store/store";

export const createNewAsphaltScenario = function (project: IProjectMetadata): IAsphaltDesignImperial {
  return {
    id: null,
    user: userStore.user ? userStore.user.id : null,
    project: project.id,
    created: new Date(Date.now()).toISOString(),
    modified: new Date(Date.now()).toISOString(),
    visible: true,
    displayUnits: project.displayUnits,
    unitSystem: UnitSystem.Imperial,
    scenarioType: BaseScenarioType.design,
    designScenarioType: DesignScenarioType.asphalt,
    isComputedFromLegacy: false,

    name: 'New Asphalt Pavement Design',
    description: null,
    state: project.state,

    completionYear: new Date(Date.now()).getFullYear(),
    roadwayClassification: null,

    // Pavement Design
    pavementType: null,

    // Design Parameters
    designPeriod_years: 15, // Years
    reliabilityLevel: 50,
    standardError: 0.5,
    initialServiceability: 4.5,
    terminalServiceability: 2,
    deltaServiceability: null,

    // Traffic and Loading
    esalCalculatedFrom: EsalCalculationMethods.design,
    // From AADT
    initialTraffic: null,
    trafficGrowthRate: null,
    esalGrowthRate: null,

    // From ESALs
    esals: null,
    loadEquivalencyFactor: null,

    // From Design ESALs
    totalDesignEsals: null,

    // Pavement Structure
    layerCoefficient: 0.44,
    drainageCoefficient: 1,
    minimumThickness: null,

    multipleLifts: false,
    surfaceLayers: [
      {
        id: null,
        coefficient: 0.44,
        drainage: 1,
        liftTitle: 'Surface',
        thickness: 1,
        modulus: 0,
      },
      {
        id: null,
        coefficient: 0.44,
        drainage: 1,
        liftTitle: 'Binder/Intermediate',
        thickness: 2,
        modulus: 0,
      },
      {
        id: null,
        coefficient: 0.44,
        drainage: 1,
        liftTitle: 'Base',
        thickness: null,
        modulus: 0,
      },
    ],
    substructureLayers: [],

    // Pavement Substructure
    existingResilientModulus: null,
    designSubgradeModulus: null,
    soilType: null,

    subgrade: null, // PSI
    cbr: null,
    rvalue: null,
    modulusCalculationMethod: null,
  };
};
